<template>
  <section>
    <Nav :step="sectorFromState.inAppStep"
         @goToLocation="goToLocation"
         @goToBase="goToBase"
         @goToDampCourse="goToMaterial"
         ref="Nav"/>
    <div class="container">
      <div class="row">
        <div class="minor__title minor__title-btn">
          Теплоизоляция
          <DeleteBtn v-if="sectors.length > 1"
                     @showDeleteConfirmation="showDeleteConfirmation"/>
        </div>
        <div class="common__pane">
          <div class="title__withToggler">
            <div class="common__title">Наличие утеплителя</div>
            <div class="wrapper">
              <span class="checkbox-toggler">
                <span class="checkbox-track"></span>
                <input type="checkbox"
                       v-model="insulation.isEnabled"
                       @change="updateInsulationNecessity">
                <span class="toggler"></span>
              </span>
            </div>
          </div>
          <div class="insulation__subtitle" v-if="insulation.isEnabled">
            Способ фиксации утеплителя
          </div>
          <div class="styled-radio__wrapper" v-if="insulation.isEnabled">
            <label class="styled-radio styled-radio__wrapper--transform"
                   :class="{'active': insulation.data.type === item.value}"
                   :for="`type-${item.value}`"
                   v-for="(item, i) in types" :key="i">
              <input type="radio"
                     v-model="insulation.data.type"
                     :value="item.value"
                     :id="`type-${item.value}`"
                     @change="updateInsulationType">
              <span class="checkmark"></span>
              <span class="styled-radio__wrapper--transform-text">{{ item.name }}</span>
            </label>
          </div>
          <div v-if="insulation.isEnabled" class="insulation__thickness">
            <div class="insulation__subtitle insulation__thickness-title">
              Толщина утеплителя, мм
            </div>
            <div class="insulation__thickness-input">
              <button @click="insulation.data.thickness -= 10; updateInsulationThickness()"
                      :disabled="insulation.data.thickness < 10"
                      class="common__plusMinus-button">
                <img src="@/assets/img/minus.svg" alt="-">
              </button>
              <input type="number"
                     class="common__plusMinus-input"
                     min="0"
                     step="10"
                     v-model.number="insulation.data.thickness"
                     @change="updateInsulationThickness">
              <button
                @click="insulation.data.thickness += 10; updateInsulationThickness()"
                class="common__plusMinus-button">
                <img src="@/assets/img/plus.svg" alt="+">
              </button>
            </div>
          </div>
        </div>
        <div class="buttons__nav wizard__buttons-nav">
          <button @click="goToBase"
                  class="common__button-prev">
            <img src="@/assets/img/common-arrow-prev.svg" alt="←">
            <span>Основание кровли</span>
          </button>
          <button @click="goToMaterial"
                  class="common__button-next"
                  :disabled="(insulation.isEnabled && insulation.data.thickness < 0)
                  || (insulation.isEnabled && insulation.data.thickness === '')">
            Гидроизоляция
            <img src="@/assets/img/common-arrow-next.svg" alt="→">
          </button>
        </div>
      </div>
    </div>
  </section>
</template>
<script>

import { mapMutations, mapState } from 'vuex';
import { dataLayerPushEvent } from '@/utils/GTM';
import Nav from '@/components/Nav.vue';
import DeleteBtn from '@/components/DeleteBtn.vue';

export default {
  data() {
    return {
      types: [
        {
          name: 'Механическая фиксация плит',
          value: 'mechanical',
        },
        {
          name: 'Приклеивание плит',
          value: 'gluing',
        },
        {
          name: 'Без фиксации',
          value: 'noFixation',
        },
      ],
    };
  },
  components: {
    Nav,
    DeleteBtn,
  },
  methods: {
    ...mapMutations({
      UPDATE_INSULATION_NECESSITY: 'UPDATE_INSULATION_NECESSITY',
      UPDATE_INSULATION_PARAM: 'UPDATE_INSULATION_PARAM',
      CLEAR_SECTOR_MATERIAL_SIZE_PARAMS: 'CLEAR_SECTOR_MATERIAL_SIZE_PARAMS',
    }),
    updateInsulationNecessity() {
      this.UPDATE_INSULATION_NECESSITY({ id: this.sectorId, val: this.insulation.isEnabled });
      if (this.isClearNeed) {
        this.CLEAR_SECTOR_MATERIAL_SIZE_PARAMS(this.sectorId);
      }
    },
    updateInsulationType() {
      this.UPDATE_INSULATION_PARAM({
        id: this.sectorId,
        param: 'type',
        val: this.insulation.data.type,
      });
      if (this.isClearNeed) {
        this.CLEAR_SECTOR_MATERIAL_SIZE_PARAMS(this.sectorId);
      }
    },
    updateInsulationThickness() {
      this.UPDATE_INSULATION_PARAM({
        id: this.sectorId,
        param: 'thickness',
        val: this.insulation.data.thickness,
      });
      if (this.isClearNeed) {
        this.CLEAR_SECTOR_MATERIAL_SIZE_PARAMS(this.sectorId);
      }
    },
    showDeleteConfirmation() {
      this.$emit('showDeleteConfirmation');
    },
    goToLocation() {
      this.$emit('goToLocation');
    },
    goToBase() {
      this.$emit('goToBase');
    },
    goToMaterial() {
      dataLayerPushEvent('calc-roofload-step4');
      this.$emit('goToDampCourse');
    },
  },
  computed: {
    ...mapState({
      sectors: state => state.sectors,
    }),
    sectorId() {
      return (this.$route.params.id) ? this.$route.params.id : 0;
    },
    sectorFromState() {
      return this.$store.getters.getSector(this.sectorId);
    },
    insulation() {
      return this.sectorFromState.insulation;
    },
    isClearNeed() {
      return this.sectorFromState.material.size.C !== ''
        || this.sectorFromState.material.size.D !== ''
        || this.sectorFromState.material.size.E !== '';
    },
  },
};
</script>
<style lang="sass" scoped>
.insulation
  &__subtitle
    color: $black
    text-align: left
    font-style: normal
    font-weight: bold
    +media((padding: (320: rem(8) 0 rem(25), 992: rem(47) 0 rem(25))))
    +media((font-size: (320: rem(13), 992: rem(14))))
    +media((line-height: (320: rem(21), 992: rem(18))))
  &__thickness
    display: flex
    flex-direction: row
    align-items: center
    justify-content: flex-start
    box-shadow: inset 0 rem(1) 0 #ECECEC
    +media((padding-top: (320: rem(24), 992: rem(34))))
    &-title
      padding: 0
      +media((padding-right: (320: rem(20), 480: rem(40))))
    &-input
      display: flex
      flex-direction: row
      align-items: center
.styled
  &-radio
    &__wrapper
      +media((padding-bottom: (320: rem(17), 768: rem(51))))
      +media((flex-direction: (320: column, 768: row)))
      display: flex
</style>
